import { Stack, Typography } from '@mui/material'
import { HoldReaction, HoldRestrictionType } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

export const HoldRestrictionChip = observer(
  ({
    restriction,
    reaction,
    fontSize,
  }: {
    restriction: HoldRestrictionType | string
    reaction: HoldReaction | string
    fontSize?: string
  }) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Stack direction='row' alignItems='center' gap={theme.customSpacing.s}>
        <Typography variant='captionBold'>{t(restriction)}:</Typography>
        <ColoredLabel label={t(reaction)} color={'secondary'} />
      </Stack>
    )
  },
)
